import * as React from 'react';

interface UseParentIdFilterParams {
  search?: string;
  parentId: string;
}

/**
 * filter function for only displaying a workspace items directly below a certain parent
 * @param search - the text of any search queries
 * @param parentId - Parent id to show direct children of
 */
export function useParentIdFilter({
  search,
  parentId,
}: UseParentIdFilterParams) {
  return React.useCallback(
    (data) => {
      // if a search query is provided, then the data is already filtered. Return data as is.
      if (search) return data;

      return data.filter((item) => {
        if (item.type === 'quiz') {
          return item.parentFolderId === parentId;
        } else {
          return item.parentId === parentId;
        }
      });
    },
    [parentId, search]
  );
}
